import type { TripLeg } from "@busbud/int-schemas/udm";

export const getSegmentIdsPerLeg = (
  trip_legs: Omit<TripLeg, "segment_xids">[]
): string[][] => {
  return (
    trip_legs
      .slice()
      // Trip legs must be always sorted, but we sort to guarantee it returns Outbund first and then the Return.
      .sort((legA, legB) => (legA.leg > legB.leg ? 1 : -1))
      .map(leg => leg.segment_ids!)
  );
};
